import { gql } from '@apollo/client'

export default gql(`
mutation createCountry($name: String!, $project: String) {
    createCountry(
        input: {
            name: $name
        },
        project: $project
    ) {
        id
        name
        assetCount
        source
    }
}`
)
